// libs
import { AnimatePresence, motion, Variants } from "framer-motion";
import styled from "styled-components";
// components
import { FlexContainer, FlexItem } from "../Flex";
import IconButton from "../IconButton";
import { Text } from "../Text";
import { Box } from "../Box";
// other
import { easings, fill } from "../../styles/utils";
import { ReactComponent as QuickQuide } from "../../assets/svg/quick_guide.svg";
import { ReactComponent as Explore } from "../../assets/svg/explore_the_scene.svg";

interface SceneGuideProps {
  showGuide: boolean;
  onCloseClick?: () => any;
}

const Wrapper = styled(motion.div)`
  ${fill()}
  z-index: 1;
`;

const Bg = styled(motion.div)`
  ${fill()}
  z-index: 0;
  backdrop-filter: blur(8px);
`;

const Container = styled(motion.div)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: ${({ theme }) => theme.colors.blue};
  color: ${({ theme }) => theme.colors.white};
  border-radius: 20px;
  padding: 40px 32px;
  max-width: 560px;
  box-shadow: ${({ theme }) => theme.shadows[1]};
`;
const CloseButtonContainer = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
`;
const SvgContainer = styled.div`
  height: 100px;
  text-align: center;

  svg {
    height: 100%;
    width: auto;
  }
`;

const containerVariants: Variants = {
  initial: { opacity: 1 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
};

const bgVariants: Variants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
};

function SceneGuide({ showGuide, onCloseClick }: SceneGuideProps) {
  return (
    <AnimatePresence>
      {showGuide && (
        <Wrapper
          initial={false}
          animate="animate"
          exit="exit"
          onClick={onCloseClick}
        >
          <Bg
            variants={bgVariants}
            transition={{ duration: 2, ease: easings.easeInCubic }}
          />
          <Container
            variants={containerVariants}
            transition={{ duration: 0.4 }}
          >
            <CloseButtonContainer>
              <IconButton icon="close" onClick={onCloseClick} size="sm" />
            </CloseButtonContainer>
            <Box textAlign="center" mb={3}>
              <Text variant="h5" lineHeight={1.4}>
                There are 8 key themes within the exhibition ready for you to
                explore
              </Text>
            </Box>
            <FlexContainer mx={-3}>
              <FlexItem px={3} flex="0 0 50%">
                <SvgContainer>
                  <Explore />
                </SvgContainer>
                <Text variant="body" lineHeight={1.4} mt={3}>
                  Drag to move around the scene and explore each theme as you go
                </Text>
              </FlexItem>
              <FlexItem px={3} flex="0 0 50%">
                <SvgContainer>
                  <QuickQuide />
                </SvgContainer>
                <Text variant="body" lineHeight={1.4} mt={3}>
                  Use our 'Quick Guide' below to dive straight into each theme
                </Text>
              </FlexItem>
            </FlexContainer>
          </Container>
        </Wrapper>
      )}
    </AnimatePresence>
  );
}

export default SceneGuide;
